module.exports = __webpack_public_path__ + "media/images/workplace/SVG/CW-Logo-da0013456fb5aef65d946a5c3985b0bc.svg";